import { PieChart } from "./PieChart";

export const MatchsPie = ({ matchs }) => {
  const win = matchs.data.filter((item) => item.victoire === "V").length;
  const loss = matchs.data.length - win;

  return (
    <>
      <h3>Victoires / Défaites</h3>
      <div className="matchs-pie">
        <PieChart
          data={[
            { label: "Victoires", value: win, color: "#377EB8" },
            { label: "Défaites", value: loss, color: "#eb525c" },
          ]}
        />
      </div>
    </>
  );
};
